import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreView',
  props: {
    pageTitle: {
      type: Object,
      required: true
    },
    themes: {
      type: Object,
      required: true
    },
    footerData: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isThemeLoadingDone: false
    };
  },
  metaInfo() {
    const pageTitle = this.pageTitle;
    const language = this.language;
    return {
      // title: this.$store.state.app.pageTitle[this.language],
      titleTemplate: () => pageTitle[language]
    };
  },
  computed: {
    ...mapState('app', ['language', 'UiTheme', 'CustomTheme', 'mode']),
    footer() {
      if (get(this.$route, 'meta.hideLayout') || this.footerData.hide) {
        return false;
      }
      return this.$route.name !== 'Maps' && this.$route.path !== '/error';
    },
    fillHeight() {
      return this.$route.path === '/error' ? 'fill-height' : '';
    },
    id() {
      if (get(this.$route, 'meta.hideLayout') && get(this.$route, 'meta.fullHeight') === false) {
        return '';
      }
      if (get(this.$route, 'meta.hideLayout') && get(this.$route, 'meta.fullHeight') === true) {
        return 'full-height-view';
      }
      return this.$route.path !== '/login' && this.$route.path !== '/error' && this.$route.path !== '/reset-password' && this.$route.path !== '/change-password' && this.$route.path !== '/oauth' && this.$route.path !== '/' ? 'core-view' : '';
    },
    backgroundStyle() {
      const isPublicDashboard = this.$route.path.startsWith('/public');
      const isFavoritesPage = this.$route.path.startsWith('/home');
      const useCustomBackground = this.$store.state.app.useCustomBackground;

      // public dashboard will always be white
      if (isPublicDashboard) {
        return 'background-color: #fff;';
      }
      const mode = this.UiTheme ? 'dark' : 'light';

      // if useCustomBackground is set and its the favorites page then use the custom theme
      if (isFavoritesPage && useCustomBackground) {
        const gradient = mode === 'dark' ? 'linear-gradient(rgba(50, 50, 50, 0.98), rgba(50, 50, 50, 0.85))' : 'linear-gradient(rgba(240, 240, 240, 0.98), rgba(240, 240, 240, 0.8))';
        if (this.themes) {
          return `background-image: ${gradient}, url(${this.themes[mode].background}); background-size: cover;`;
        } else {
          return `background-image: ${gradient}; background-size: cover;`;
        }
      }

      // otherwise use default colors for the theme mode
      return `background-color: ${mode === 'light' ? '#E5E5E5' : '#2d2d2d'};`;
    }
  }
};